import React from 'react';

const InstantBooking = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd">
      <circle
        cx="12"
        cy="12"
        r="11.25"
        fill="#FFF"
        stroke="#FFA900"
        strokeWidth="1.5"
      />
      <path
        fill="#FFA900"
        fillRule="nonzero"
        d="M8 13.234h3.369l-.87 6.58 5.493-9.615h-3.194L13.748 4z"
      />
    </g>
  </svg>
);

export default InstantBooking;
